import type { IconData } from '@stacksjs/iconify-core'

export const screen1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path stroke-linecap=\"round\" d=\"m27.999 35.004l.678 3.392a2 2 0 0 0 1.961 1.608h.901a3 3 0 0 1 2.942 2.412l.04.196a2 2 0 0 1-1.962 2.392h-17.12a2 2 0 0 1-1.962-2.392l.04-.196a3 3 0 0 1 2.941-2.412h.901a2 2 0 0 0 1.961-1.608l.68-3.392\"/><path d=\"M3.444 30.046c.235 2.528 2.24 4.385 4.774 4.543c3.225.2 8.388.413 15.782.413s12.557-.213 15.782-.413c2.534-.158 4.539-2.015 4.774-4.543c.23-2.476.444-6.107.444-11.044s-.214-8.568-.444-11.044c-.235-2.528-2.24-4.385-4.774-4.543c-3.225-.2-8.388-.413-15.782-.413s-12.557.212-15.782.413c-2.534.158-4.539 2.015-4.774 4.543C3.214 10.433 3 14.064 3 19.002s.214 8.568.444 11.044Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default screen1
